import { render, staticRenderFns } from "./DownloadFilesPopUp.vue?vue&type=template&id=3f334690"
import script from "./DownloadFilesPopUp.vue?vue&type=script&lang=js"
export * from "./DownloadFilesPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports